export const DEFAULT_FALLBACK_COLORS = [
  { hex: "#E0E0E0", weight: 0.2 },
  { hex: "#B0B0B0", weight: 0.2 },
  { hex: "#808080", weight: 0.2 },
  { hex: "#505050", weight: 0.15 },
  { hex: "#303030", weight: 0.15 },
  { hex: "#101010", weight: 0.1 },
];
